
import { environment } from 'src/environments/environment';
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { User } from "./models/user";
import { EUserType } from "./enum/e-user-type";
import { Package } from '../packages/models/package';
import { Subscription } from '../subscription/models/subscription';

@Injectable({
providedIn: 'root'
})
export class UserApiService {
  
  private baseUrl: string = environment.apiUrl;

  constructor(private http: HttpClient) {
  }

  getApiUrlCall(endUrl) {
    return this.baseUrl + endUrl;
  }
  
  getUsers(userType : EUserType): Observable<User[]> {
    const url = this.getApiUrlCall('api/Users/' + userType);
    return this.http.get<User[]>(url);
  }

  getUser(userId : number): Observable<User> {
    const url = this.getApiUrlCall('api/Users/' + userId);
    return this.http.get<User>(url);
  }
  
  createUser(user: User): Observable<User> {
    const url = this.getApiUrlCall('api/Users');
    return this.http.post<User>(url, user);
  }

  deleteUser(user: User): Observable<number> {
    const url = this.getApiUrlCall("api/Users/" + user.id);
    return this.http.delete<number>(url);
  }

  editUser(user: User): Observable<any> {
    const url = this.getApiUrlCall("api/Users/" + user.id);
    return this.http.put(url, user);
  }

  getPackage(user : User) : Observable<Package[]> {
    const url = this.getApiUrlCall("api/Users/GetPackages");
    return this.http.post<Package[]>(url, user);
  }

  getSubscriptions(user : User) : Observable<Subscription[]> {
    const url = this.getApiUrlCall("api/Users/GetUserSubscriptions");
    return this.http.post<Subscription[]>(url, user);
  }

}

